import { DatePipe } from '@angular/common';
import { Component, computed, input, OnInit, signal } from '@angular/core';

@Component({
  selector: 'app-calendar-days',
  templateUrl: './calendar-days.component.html',
  styleUrls: ['./calendar-days.component.scss'],
  standalone: true,
  imports: [DatePipe],
})
export class CalendarDaysComponent {
  readonly locale = input.required<string>();
  readonly selectedDate = input(new Date());

  protected readonly daysToDisplay = computed(() => {
    const selected = this.selectedDate();

    const dayOfWeek = selected.getDay();
    const mondayOffset = dayOfWeek === 0 ? -6 : 1 - dayOfWeek;
    const monday = new Date(selected);
    monday.setDate(selected.getDate() + mondayOffset);

    const days: Date[] = [];
    for (let i = 0; i < 7; i++) {
      const day = new Date(monday);
      day.setDate(monday.getDate() + i);
      days.push(day);
    }
    return days;
  });

  protected isSelected(date: Date) {
    const selected = this.selectedDate();
    return date.getDate() === selected.getDate();
  }
}
